module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showBanner) ? _c('div', {
    staticClass: "top-banner-out"
  }, [(_vm.innerBanner) ? _c('div', {
    staticClass: "top-banner"
  }, [_c('div', {
    staticClass: "t-app"
  }, [(_vm.icon) ? _c('img', {
    attrs: {
      "onerror": "this.style.display='none'",
      "src": _vm.icon,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.appName) ? _c('span', {
    staticClass: "app-name"
  }, [_vm._v(_vm._s(_vm.appName))]) : _vm._e(), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (!_vm.detail) ? _c('span', {
    staticClass: "to-app openappAndroidwx wx-launch-app-btn-parent"
  }, [_vm._v("打开APP参与话题")]) : _vm._e(), _vm._v(" "), (_vm.detail) ? _c('span', {
    staticClass: "to-app",
    on: {
      "click": _vm.openTopic
    }
  }, [_vm._v("查看完整话题")]) : _vm._e(), _vm._v(" "), (_vm.showPopover) ? _c('Popover', {
    attrs: {
      "appName": _vm.appName,
      "topicInfo": _vm.topicInfo
    },
    on: {
      "openAppOrTopic": _vm.openAppOrTopic,
      "openTopic": _vm.openTopic
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "t-tip"
  }, [_c('span', {
    staticClass: "t-line"
  }), _vm._v(" "), _c('span', {
    staticClass: "t-w"
  }, [_vm._v("话题")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-073f1b00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topBanner.vue
// module id = 313
// module chunks = 1